import {
  FETCH_JOB_ALERT_PREFERENCES,
  FETCH_JOB_SEEKER_SAVED_JOBS,
  JOB_SEEKER_INITIAL_STATE,
} from "./jobSeekerConstants";
import { SIGN_OUT_USER } from "../auth/authConstants";

export default function jobSeekerReducer(
  state = JOB_SEEKER_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case FETCH_JOB_SEEKER_SAVED_JOBS:
      return {
        ...state,
        savedJobs: payload,
      };
    case FETCH_JOB_ALERT_PREFERENCES:
      return {
        ...state,
        jobAlertPreferences: payload,
      };
    case SIGN_OUT_USER:
      return {
        ...state,
        ...JOB_SEEKER_INITIAL_STATE,
      };
    default:
      return state;
  }
}
